import { render } from "./TableRow_2grid.vue?vue&type=template&id=4379d4ae&scoped=true"
import script from "./TableRow_2grid.vue?vue&type=script&lang=js"
export * from "./TableRow_2grid.vue?vue&type=script&lang=js"

import "./TableRow_2grid.vue?vue&type=style&index=0&id=4379d4ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4379d4ae"]])

export default __exports__